import { Comment, Events, eventsManager } from "@rhinov/savane-js";
import { EntityController } from "./EntityController";



export class CommentEntityController extends EntityController {

    declare entity: Comment;

    constructor(entity: Comment, panel: any) {
        super(entity, panel, undefined as any);
    }

    removeCommentImage = (image: string) => {
        var index = this.entity.images.indexOf(image);
        if (index !== -1) {
            var images = this.entity.images;
            images.splice(index, 1);
            this.entity.images = images;
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT, {
                editedProperty: "images",
                value: images,
                obj: this.entity
            });
        }
    };

    addCommentImage() {
        var entity = (this.entity as any)
        if (entity.image) {
            entity.image = entity.image.trim();
            if (this.entity.images.indexOf(entity.image) !== -1) {
                entity.image = null;
                return;
            }
            var images = this.entity.images;
            images.push(entity.image);
            this.entity.images = images;
            entity.image = null;
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT, {
                editedProperty: "images",
                value: images,
                obj: this.entity
            });
        }
    };
}